<template>
  <div class="execution-error">
    <span class="chunk-status-icon chunk-status-icon--error">
      <BbIcon size="small" name="x-small" />
    </span>
    <div class="execution-error__text" v-html="renderedHtml"></div>
  </div>
</template>

<script>
import { computed } from 'vue';

import { sanitizeAndParse } from '~/utils/message';

export default {
  name: 'ExecutionErrorMessage',
  props: {
    content: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const renderedHtml = computed(() => sanitizeAndParse(props.content));

    return { renderedHtml };
  },
};
</script>

<style scoped lang="scss">
.execution-error {
  display: flex;
  align-items: flex-start;
  gap: $bb-spacing-2;
}

.chunk-status-icon {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  margin-top: 2px;
}
.chunk-status-icon--error {
  width: 16px;
  height: 16px;
  background: #fee2e2;
  color: $bb-interface-5 !important;
}

.execution-error__text {
  color: $bb-interface-5 !important;
  font-weight: bold;
  word-break: break-word;
  font-size: 15px;
  line-height: $bb-spacing-5;
}
</style>
